import {
    MODEL_CONFIGS_CANCEL_FETCH,
    MODEL_CONFIGS_CLEAR,
    MODEL_CONFIGS_FETCH,
    MODEL_CONFIGS_RETRY_FETCH,
    MODEL_CONFIGS_SAVE_ERROR,
    MODEL_CONFIGS_SET,
    MODEL_CONFIGS_SET_PRELOADED_CONFIGS
} from './constants';
import {IListConfig} from '@src/@interfaces/components/List/IListConfig';
import {IFormConfig} from '@src/@interfaces/components/Form/IFormConfig';
import {IReduxModelConfigsState} from '@src/@interfaces';

export const fetchModelConfig = (controllerName: string) => ({type: MODEL_CONFIGS_FETCH, payload: controllerName});

export const cancelFetchModelConfig = (controllerName: string) => ({
    type: MODEL_CONFIGS_CANCEL_FETCH,
    payload: controllerName
});

export const retryFetchModelConfig = (controllerName: string) => ({
    type: MODEL_CONFIGS_RETRY_FETCH,
    payload: controllerName
});

export const setModelConfigs = (controllerName: string, configs: {
    'list-config'?: IListConfig,
    'form-config'?: IFormConfig,
    'import-config'?: IFormConfig,
}) => ({
    type: MODEL_CONFIGS_SET,
    payload: {controllerName, configs}
});

export const setModelPreloadedConfigs = (configs: Pick<IReduxModelConfigsState, 'listConfigs' | 'formConfigs'>) => ({
    type: MODEL_CONFIGS_SET_PRELOADED_CONFIGS,
    payload: configs
});

export const clearModelConfigs = () => ({type: MODEL_CONFIGS_CLEAR});

export const saveModelConfigError = (controllerName: string, error: Error) => ({
    type: MODEL_CONFIGS_SAVE_ERROR,
    payload: {
        controllerName,
        error: {
            name: error.name,
            message: error.message,
        }
    }
});
